// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__ikCev","switch--active":"switch_switch--active__EWK0_","button":"switch_button__MY6jN","button--active":"switch_button--active__jAmzZ"};